import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoneyPipe } from './money.pipe';
import { UtilitiesService } from '../../services/utilities.service';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ MoneyPipe ],
    exports: [ MoneyPipe ],
    providers: [ UtilitiesService ],
})
export class MoneyPipeModule {}
